import { render, staticRenderFns } from "./TvtimeImporterPage.vue?vue&type=template&id=8febfa3a&scoped=true"
import script from "./TvtimeImporterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TvtimeImporterPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TvtimeImporterPage.vue?vue&type=style&index=0&id=8febfa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8febfa3a",
  null
  
)

export default component.exports